import React, { useState, useEffect } from 'react';
import api from '../../api/client';

export default function CustomerDevices() {
  const [devices, setDevices] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = async () => {
    setLoading(true);
    try {
      const { data } = await api.get('/devices/status');
      setDevices(data.data || []);
    } finally { setLoading(false); }
  };

  useEffect(() => { load(); const iv = setInterval(load, 30000); return () => clearInterval(iv); }, []);

  const online = devices.filter(d => d.status === 'online').length;

  return (
    <div>
      <div className="page-header" style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between' }}>
        <div>
          <h1>Cihazlar</h1>
          <p>{online}/{devices.length} cihaz çevrimiçi</p>
        </div>
        <button className="btn btn-secondary" onClick={load}>↻ Yenile</button>
      </div>

      {loading ? (
        <div style={{ display: 'flex', gap: 12, color: 'var(--text3)' }}><span className="spinner" /> Yükleniyor...</div>
      ) : (
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(300px, 1fr))', gap: 14 }}>
          {devices.map(d => (
            <div key={d.id} className="card" style={{ borderLeft: `4px solid ${d.status === 'online' ? 'var(--green)' : 'var(--text3)'}` }}>
              <div style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', marginBottom: 12 }}>
                <div>
                  <h3 style={{ fontSize: 15, marginBottom: 3 }}>{d.name}</h3>
                  <div style={{ fontSize: 11, color: 'var(--text3)', fontFamily: 'monospace' }}>{d.device_key}</div>
                </div>
                <span style={{ display: 'flex', alignItems: 'center', gap: 5, fontSize: 12, color: d.status === 'online' ? 'var(--green)' : 'var(--text3)' }}>
                  <span style={{ width: 8, height: 8, borderRadius: '50%', background: d.status === 'online' ? 'var(--green)' : 'var(--text3)', display: 'block', boxShadow: d.status === 'online' ? '0 0 8px var(--green)' : 'none' }} />
                  {d.status === 'online' ? 'Çevrimiçi' : 'Çevrimdışı'}
                </span>
              </div>
              {d.location && <div style={{ fontSize: 12, color: 'var(--text2)', marginBottom: 8 }}>📍 {d.location}</div>}
              <div style={{ fontSize: 11, color: 'var(--text3)' }}>
                Son görülme: {d.last_seen ? new Date(d.last_seen).toLocaleString('tr-TR') : 'Hiç'}
              </div>
              {d.seconds_since_last_seen !== null && d.status === 'online' && (
                <div style={{ fontSize: 11, color: 'var(--green)', marginTop: 3 }}>
                  {Math.floor(d.seconds_since_last_seen / 60)} dakika önce aktifti
                </div>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
